import { useEffect, useRef, useState } from "react";

const DEFAULT_SMS_SEND_COOLDOWN = 30;

type UseSendSmsCooldownOptions = {
  cooldownDuration?: number;
};

export const useSendSmsCooldown = ({
  cooldownDuration = DEFAULT_SMS_SEND_COOLDOWN,
}: UseSendSmsCooldownOptions = {}) => {
  const [sendSmsCooldown, setSendSmsCooldown] = useState(0);
  const cooldownTimerRef = useRef<NodeJS.Timeout | null>(null);

  const clearTimer = () => {
    if (cooldownTimerRef.current) {
      clearInterval(cooldownTimerRef.current);
      cooldownTimerRef.current = null;
    }
  };

  const triggerCooldown = () => {
    clearTimer();
    setSendSmsCooldown(cooldownDuration);
    cooldownTimerRef.current = setInterval(() => {
      setSendSmsCooldown((prev) => Math.max(0, prev - 1));
    }, 1000);
  };

  useEffect(() => {
    if (sendSmsCooldown <= 0) {
      clearTimer();
    }

    return clearTimer;
  }, [sendSmsCooldown]);

  return {
    sendSmsCooldown,
    triggerCooldown,
    isCooldownActive: sendSmsCooldown > 0,
  };
};
